import createConverter from './lib/create_converter';
import Team from 'models/team';

export default createConverter(Team);
